export default class DatasetCategory {
  public id: number;
  public label = "";
  public datasets_count = 0;
}
